// extracted by css-extract-rspack-plugin
export default {"badge":"_52efe526","isDraft":"_f00259fc","isNotVisible":"_2d0ca062"};